import { FC } from 'react';
import { Newsletter } from '../../../shared/components/Newsletter';
import { FAQ } from './FAQ';
import Offerings from './Offerings';
import Partnerships from './Partnerships';

const What: FC = () => (
    <>
        <div>
            <Offerings />
            <FAQ />
            <Newsletter
                header="Want to learn more about satellite data?"
                description="Satellite data is the next generation of maritime insights. Learn about the possibilities and get ahead of the curve. Sign up for our email introduction into the word of machine learning and maritime satellite insight."
            />
            <Partnerships />
        </div>
    </>
);

export default What;
